import React from 'react'
import "./Footer.css";

function Footer() {
    return (
        <div className="footer">
            <div className="footer__icons">
                <i class="fab fa-facebook-f"></i>
                <i class="fab fa-twitter"></i>
                <i class="fab fa-twitch"></i>
                <i class="fab fa-youtube"></i>
                <i class="fab fa-instagram"></i>
                <i class="fab fa-snapchat-ghost"></i>
                <i class="fab fa-vk"></i>
            </div>
            <div className="displayFlex">
                <div className="footer__titles">
                    <li>Home</li>
                    <li>Battle Pass</li>
                    <li> Watch</li>
                    <li>Get Fortnite</li>
                </div>

                <div className="footer__titles1">
                    <li>News</li>
                    <li>FAQ</li>
                    <li> EULA</li>
                    <li>Competitive</li>
                </div>

                <div className="footer__titles2">
                    <li>V-Bucks Card</li>
                    <li>Help</li>
                    <li> Safety and Security</li>
                    <li>  Community Rules</li>
                </div>
            </div>

            <div className="bottom__to__up">
                <a href="#">
                    <i class="fas fa-angle-up">
                        </i>
                        </a>
            </div>

            <div className="border__bottom">
            </div>

            <div className="footer__des">
                <p>© 2021, Epic Games, Inc. Epic, Epic Games, the Epic Games logo, Fortnite, the Fortnite logo, Unreal, Unreal Engine 4 and UE4 are trademarks or registered trademarks of Epic Games, Inc. in the United States of America and elsewhere. All rights reserved. Code by - Abhishek Pravin Kuntare.  </p>
            </div>

            <div className="conditions">
                <div className="footer_terms">
                    Terms of Service
                </div>
                <div className="footer__privacy">
                    Privacy Policy
                </div>
            </div>

            <div className="footer__bottom__icons">

                <i class="fab fa-playstation"></i>

                <i class="fab fa-xbox"></i>

                <i class="fas fa-gamepad"></i>

                <i class="fab fa-android"></i>

                <i class="fab fa-xing"></i>

                <i class="fab fa-studiovinari"></i>

                <i class="fas fa-superscript"></i>

                <i class="fab fa-gulp"></i>

                <i class="fab fa-grunt"></i>

                <i class="fab fa-fantasy-flight-games"></i>

                <i class="fab fa-wizards-of-the-coast"></i>

                <i class="fab fa-critical-role"></i>

                <i class="fab fa-penny-arcade"></i>

                <i class="fas fa-dice-d6"></i>

            </div>

        </div>
    )
}

export default Footer
